<template src="./summary-dim-rating.html"></template>

<script lang="ts">

export default {
  props: {
    averageRating: {
      type: Number,
      default: 0.0
    },
    headingLevel: { type: Number, default: 3 }
  },
  computed: {
    ratingPercentage() {
      return `${(this.averageRating / 5.0 * 100).toFixed(1)}%`
    }
  }
}
</script>

<style lang="scss" src="./summary-dim.scss"></style>
<style lang="scss" src="./summary-dim-rating.scss"></style>
